import { Component, OnInit, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-caracteristica-input',
  templateUrl: './caracteristica-input.component.html',
  styleUrls: ['./caracteristica-input.component.scss']
})
export class CaracteristicaInputComponent implements OnInit {
  readonly TIPO_OPCIONES: number = 1;
  readonly TIPO_TEXTO: number = 2;

  // datos de la característica: opciones posibles, tipo ...etc
  model: any;
  // controlador del input, al que se le asigna el valor que elije el usuario.
  @Input('caracteristica') caracteristica: FormGroup;

  constructor() { }


  ngOnInit() {
    if (!this.caracteristica) {
      throw "La variable Input 'caracteristica' es requerida";
    }

    this.model = this.caracteristica.get('model').value;
  }
}
